import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material'
import { Stack } from '@mui/system'
import { FC } from 'react'

interface SoilTableProps {
  rows: {
    id: string
    soil_description: string
    water_reference: string
    holding_capacity: string
    wilting_point: string
    intake_rate: string
    surface: string
  }[]
}

const SoilTable: FC<SoilTableProps> = ({ rows }) => {

  return (
    <Stack spacing={57}>
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          backgroundColor: 'common.white',
          border: '1px solid #EFEFEF',
          borderRadius: '3px',
        }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead sx={{ backgroundColor: '#EFEFEF' }}>
            <TableRow>
              <TableCell sx={{ width: '29px' }}>#</TableCell>
              <TableCell
                sx={{
                  width: '182px',
                  borderRight: '1px solid #D7D7D7',
                }}
              >
                Description
              </TableCell>
              <TableCell
                sx={{
                  width: '225px',
                }}
              >
                Water Reference
              </TableCell>
              <TableCell
                sx={{
                  width: '225px',
                }}
              >
                Holding Capacity
              </TableCell>
              <TableCell
                sx={{
                  width: '225px',
                }}
              >
                Wilting Point
              </TableCell>
              <TableCell
                sx={{
                  width: '225px',
                }}
              >
                Intake Rate
              </TableCell>
              <TableCell
                sx={{
                  width: '225px',
                }}
              >
                Max Surface Accumulation
              </TableCell>

            </TableRow>
          </TableHead>
          <TableBody sx={{ backgroundColor: 'common.white' }}>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell component="th" scope="row">
                  {row.id}
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: '1px solid #D7D7D7',
                  }}
                >
                  {row.soil_description}
                </TableCell>
                <TableCell>{row.water_reference}</TableCell>
                <TableCell>{row.holding_capacity}</TableCell>
                <TableCell>{row.wilting_point}</TableCell>
                <TableCell>{row.intake_rate}</TableCell>
                <TableCell>{row.surface}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  )
}

export default SoilTable
